import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiBuilder,
  AppConfigService,
  HttpHeadersPayload,
  HttpRequestMethods,
  LoggingService
} from '@com-delta-idp/mnx-utils';
import { from, Observable, throwError } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { HEADER, SBW_TIMEOUT } from '../constants/common.constants';
import { FlightShopWidgetTemplates } from '../constants/flight-shop.constants';
import { EndpointKeys, IDP_APPS } from '../constants/urls.constants';
import { SavedSearchResponse } from '../models/core-apis/saved-search.interfaces';
import { UserAuthServices } from './book-options-user-auth.service';
import { SitewideUserAuthServices } from './sitewide-book-options-user-auth.service';

@Injectable({
  providedIn: 'root'
})
export class SavedSearchService {
  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private logging: LoggingService,
    private userAuthServices: UserAuthServices,
    private sitewideUserAuthServices: SitewideUserAuthServices
  ) {}

  getSavedSearch(
    flightShopWidgetTemplate: FlightShopWidgetTemplates
  ): Observable<SavedSearchResponse> {
    const service =
      flightShopWidgetTemplate === FlightShopWidgetTemplates.HOME
        ? this.sitewideUserAuthServices
        : this.userAuthServices;

    return from(service.fetchAccessToken()).pipe(
      switchMap((token) => {
        const headers: HttpHeadersPayload = {
          [HEADER.AUTHORIZATION]: `${HEADER.BEARER} ${token}`,
          channelId: 'ecom',
          Appid: 'cus'
        };

        return new ApiBuilder<string, SavedSearchResponse>(
          this.http,
          this.appConfig
        )
          .app(IDP_APPS.BOOK_WIDGET)
          .endpointKey(EndpointKeys.SAVED_SEARCH)
          .method(HttpRequestMethods.GET_HEADERS)
          .httpHeaders(headers)
          .timeOut(SBW_TIMEOUT.COMMON)
          .errorHandler(this._handleError.bind(this))
          .create();
      })
    );
  }

  private _handleError(error: HttpErrorResponse): Observable<never> {
    this.logging.log(error.message);
    return throwError(error);
  }
}
